import React from "react";

const JDOptionsModal = ({ onClose, onUpload, onCreateAI }) => {
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop fade show" />

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        style={{ zIndex: 1056 }}
        onClick={onClose}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          onClick={stopPropagation}
        >
          <div className="modal-content shadow-sm border-0 rounded-3">
            {/* Header */}
            <div className="modal-header bg-light border-bottom">
              <h5 className="modal-title fw-semibold mb-0">
                Create Job Description
              </h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onClose}
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body bg-white py-4 px-4">
              <button
                className="btn btn-primary w-100 mb-3 d-flex align-items-center justify-content-center gap-2"
                onClick={onUpload}
              >
                <i className="fa-solid fa-upload"></i>
                Upload Existing JD
              </button>

              <button
                className="btn btn-secondary w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={onCreateAI}
              >
                <i className="fa-solid fa-robot"></i>
                Generate with AI
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JDOptionsModal;
